import axios from "axios";
import { API_URL } from "../../config/config";
import API from "../../common/API";

/*** 
@purpose : Get BU list
@Parameter : {}
**/
export const fetchTerritoryBUList = async (wwid,cnt) => {
    const token = sessionStorage.getItem("token");
    // const wwid = sessionStorage.getItem("WWID");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_TERRITORY_BU_LIST + `?timestamp=${timestamp}&currentMonth=${cnt}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "wwid": wwid, "timestamp": timestamp, mode: 'no-cors'}}).then((response) => {
      if (response.data.success == true && response.data.data) {
        response.data.data[0].maintenanceWindowFlag = response.data.maintenanceWindowFlag
        return response.data.data;
      }
    });
  };
  
  /*** 
  @purpose : Get division list
  @Parameter : {}
  **/
  export const fetchTerritoryDivisionList = async (value,cnt) => {
    const token = sessionStorage.getItem("token");
    const wwid = sessionStorage.getItem("WWID");
    let timestamp = new Date().getTime()
    return await axios
      .get(API_URL + API.GET_TERRITORY_DIVISION_LIST + `?buID=${value}&timestamp=${timestamp}&currentMonth=${cnt}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "wwid": wwid, "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };
  
    /*** 
  @purpose : Get Default Maintenance Window
  @Parameter : {}
  **/
  export const getDefaultMaintenanceWindow = async (value,cnt) => {
    const token = sessionStorage.getItem("token");
    const wwid = sessionStorage.getItem("WWID");
    let timestamp = new Date().getTime()
    return await axios
      .get(API_URL + API.GET_MAINTAINANCE + `?timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "wwid": wwid, "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        if (response.data) {
          return response.data;
        }
      });
  };
  

  /*** 
  @purpose : Get branch list
  @Parameter : {}
  **/
  export const fetchTerritoryBranchList = async (value) => {
    const token = sessionStorage.getItem("token");
    const wwid = sessionStorage.getItem("WWID");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_TERRITORY_BRANCH_LIST + `?buID=${value.buID}&divisionID=${value.divisionID}&timestamp=${timestamp}&currentMonth=${value.currentMonth}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "wwid": wwid, "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };
  
  /*** 
  @purpose : Get sales office list
  @Parameter : {}
  **/
  export const fetchTerritorySalesOfficeList = async (value) => {
    const token = sessionStorage.getItem("token");
    const wwid = sessionStorage.getItem("WWID");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_TERRITORY_SALES_OFFICE_LIST + `?buID=${value.buID}&divisionID=${value.divisionID}&branchID=${value.branchID}&currentMonth=${value.currentMonth}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "wwid": wwid, "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };

  /*** 
  @purpose : Get sales office list
  @Parameter : {}
  **/
  export const fetchTerritoryList = async (value) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_TERRITORY_LIST + `?buID=${value.buID}&divisionID=${value.divisionID}&branchID=${value.branchID}&salesOfficeID=${value.salesOfficeID}&currentMonth=${value.currentMonth}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };

  /*** 
  @purpose : Get territory allocation list
  @Parameter : {}
  **/
  export const getTerritoryAllocationList = async (body) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_TERRITORY_ALLOCATION_LIST + `?territorySetID=${body.territoryID}&salesOfficeID=${body.salesOfficeID}&currentMonth=${body.currentMonth}&limit=${body.limit}&totalRecords=${body.totalRecords}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        
        if (response.data.success == true) {
          return response.data;
        }
      });
  };

  /*** 
  @purpose : Get territory blocks list
  @Parameter : {}
  **/
  // export const getTerritoryBlocksList = async (body) => {
  //   const token = sessionStorage.getItem("token");
  //   let timestamp = new Date().getTime()
  //   return await axios.get(API_URL + API.GET_BLOCKS_LIST + `?salesOfficeID=${body.salesOfficeID}&territorySetID=${body.territorysetID}&filter=${body.filter}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'}})
  //     .then((response) => {
  //       if (response.data.success == true && response.data.data) {
  //         return response.data;
  //       }
  //     });
  // };

  export const getTerritoryBlocksList = async (body) => {
    const token = sessionStorage.getItem("token");
    const wwid = sessionStorage.getItem("WWID");
    return fetch(API_URL + API.GET_BLOCKS_LIST, {
      method: "post",
      headers: { 'x-api-key': token, 'wwid': wwid, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600},
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data;
      });
  };

    /*** 
  @purpose : Delete territory definition
  @Parameter : {}
  **/

  export const restoreTerritory = async (body) => {
    const token = sessionStorage.getItem("token");
    const wwid = sessionStorage.getItem("WWID");
    return fetch(API_URL + API.RESTORE_TERRITORY, {
      method: "post",
      headers: { 'x-api-key': token, 'wwid': wwid, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600},
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data;
      });
  };

  /*** 
  @purpose : Get blocks by territory
  @Parameter : {}
  **/
  export const getBlocksbyTerritory = async (id) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_BLOCKS_BY_TERRITORY + `?territoryDefinitionID=${id}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };

  /*** 
  @purpose : Get territory blocks list
  @Parameter : {}
  **/
  export const getFacilitiesList = async (id) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_FACILITIES_LIST + `?blockID=${id}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };

  /*** 
  @purpose : Save territory definition
  @Parameter : {}
  **/
  export const saveTerritoryDefinition = async (body) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    const wwid = sessionStorage.getItem("WWID");
    return fetch(API_URL + API.SAVE_TERRITORY_DEFINITION_LIST, {
      method: "post",
      headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', 'wwid': wwid, "timestamp": timestamp, mode: 'no-cors'},
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data;
      });
  };

  /*** 
  @purpose : Get territory blocks list
  @Parameter : {}
  **/
  // export const applyBlocksFilter = async (body) => {
  //   const token = sessionStorage.getItem("token");
  //   let timestamp = new Date().getTime()
  //   return await axios.get(API_URL + API.GET_BLOCKS_LIST + `?salesOfficeID=${body.salesOfficeID}&territorySetID=${body.territorysetID}&territoryDefinitionID=${body.territoryDefinitionID}&filter=${body.filter}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'}})
  //     .then((response) => {
  //       if (response.data.success == true && response.data.data) {
  //         return response.data.data;
  //       }
  //     });
  // };

  export const applyBlocksFilter = async (body) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    const wwid = sessionStorage.getItem("WWID");
    return fetch(API_URL + API.GET_BLOCKS_LIST, {
      method: "post",
      headers: { 'x-api-key': token, 'wwid': wwid, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600},
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data;
      });
  };
  